var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m16.064 10.162 1.607-1.607a6.023 6.023 0 0 1 8.518 0 6.24 6.24 0 0 1 .154 8.667l-9.547 10.252a1 1 0 0 1-1.463 0L5.785 17.222a6.24 6.24 0 0 1 .155-8.667 6.023 6.023 0 0 1 8.518 0z"
})));
export default SvgHeart;